<template>
	<div v-show="shown">
		<div v-for="fontFamily in fontFamilies" :key="fontFamily" :style="{ fontFamily: `${fontFamily} !important`, height: 0, overflow: 'hidden' }">
			{{ fontFamily }}
		</div>
	</div>
</template>
<script>
import { signatureFontFamilies } from "./Annotations.js";

export default {
	data() {
		return {
			fontFamilies: signatureFontFamilies,
			shown: true
		};
	},
	mounted() {
		setTimeout(() => this.shown = false, 500);
	}
};
</script>